export enum StickyAnchorEventTypeEnum {
  click = 'click',
  scroll = 'scroll'
}
